export enum Role {
  GlobalAdmin = 'GlobalAdmin',
  Admin = 'Admin',
  PoolMenuView = 'PoolMenuView',
  WorkflowMenuView = 'WorkflowMenuView',
  ProductMenuView = 'ProductMenuView',
  ReportMenuView = 'ReportMenuView',
  BKServices = 'BKServicesView'
}
